import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Table, Row, Col, Switch, Pagination } from 'antd';
import 'ant-design-pro/dist/ant-design-pro.css';
import date from '../../helpers/date';
import PopConfirm from '../../components/PopConfirmComponent';
import {
  EDIT_COUPON,
  REMOVE_COUPON,
  GET_COUPON_LIST,
  COUPON_IS_DELETED,
  COUPON_IS_EDITED
} from '../../state/coupon/types';
import { RESOURCE } from '../../config/constants/alerts';
import { STATUS } from '../../config/constants/states';
import PropTypes from 'prop-types';

const { formatString } = date;

const CouponDetailTable = ({
  listIsLoaded,
  couponList,
  activeCoupon,
  inactiveCoupon,
  removeCoupon,
  isEdited,
  isDeleted,
  getCouponList,
  resetEditStates,
  resetDeleteStates
}) => {

  const [loaderSpinning, setLoaderSpinning] = useState(true);
  const pageSize = 10;

  useEffect(() => {
    getCouponList({ page: 1, limit: 10 });
    resetEditStates();
    resetDeleteStates();
  }, [isEdited, isDeleted]);

  useEffect(() => {
    if (listIsLoaded) {
      setLoaderSpinning(false);
    } else {
      setLoaderSpinning(true);
    }
  }, [listIsLoaded]);

  const onChangeSwitch = (value, id) => {
    if (value) {
      activeCoupon({
        active: true,
        id: id
      });
    } else {
      inactiveCoupon({
        active: false,
        id: id
      });
    }
  };

  const remove = (id) => {
    removeCoupon(id);
  };

  const data = couponList.docs && couponList.docs[0] ? couponList.docs.map((document, index) => ({
    key: index,
    rut: document.whiteList,
    code: document.code,
    maxRedemptions: document.maxRedemptions,
    timesRedeemed: document.timesRedeemed,
    amountOff: document.amountOff ? `$${document.amountOff.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}` : `${document.percentageOff}%`,
    description: document.description,
    expirationDate: formatString(document.expirationDate),
    state: document.active ? 'Activo' : 'Inactivo',
    action:
      <Row className='border: 0'>
        <Col xs={24} md={12}>
          <Switch checked={document.active} onChange={(value) => onChangeSwitch(value, document._id)} />
        </Col>
        <Col xs={24} md={12}>
          <PopConfirm
            title='¿Está seguro?'
            okText='Eliminar'
            cancelText='cancelar'
            onConfirm={() => remove(document._id)}
            buttonType='link'
            buttonText='Eliminar'
          />
        </Col>
      </Row>
  })) : [];


  /**
   * Array of objects with table column information
   */
  const columns = [
    {
      title: 'Código de cupón',
      dataIndex: 'code',
    },
    {
      title: 'Rut beneficiario',
      dataIndex: 'rut',
    },
    {
      title: 'Total de usos',
      dataIndex: 'maxRedemptions',
    },
    {
      title: 'Cantidad de usos',
      dataIndex: 'timesRedeemed',
    },
    {
      title: 'Descuento',
      dataIndex: 'amountOff',
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
    },
    {
      title: 'Fecha de expiración',
      dataIndex: 'expirationDate',
    },
    {
      title: 'Estado',
      dataIndex: 'state',
    },
    {
      title: 'Acción',
      dataIndex: 'action',
      width: 200,
      fixed: 'right',
    },
  ];

  const PaginationTable = () => {
    const getMoreDocs = (page, selectedPageSize) => {
      getCouponList({ page: page, limit: selectedPageSize });
    };
    return (
      <Pagination
        defaultCurrent={couponList.page}
        total={!couponList.totalDocs ? 1 : couponList.totalDocs}
        onChange={getMoreDocs}
        pageSize={pageSize}
      />
    );
  };

  return (
    <>
      <div className="site-card-wrapper">
        <Table
          columns={columns}
          dataSource={data}
          scroll={{ x: 1300, y: 400 }}
          pagination={false}
          loading={loaderSpinning}
        />
      </div>
      <Col xs={24} className="d-flex justify-content-end">
        <PaginationTable />
      </Col>
    </>
  );
};

CouponDetailTable.propTypes = {
  listIsLoaded: PropTypes.bool.isRequired,
  couponList: PropTypes.object.isRequired,
  activeCoupon: PropTypes.func.isRequired,
  inactiveCoupon: PropTypes.func.isRequired,
  removeCoupon: PropTypes.func.isRequired,
  isEdited: PropTypes.bool.isRequired,
  isDeleted: PropTypes.bool.isRequired,
  getCouponList: PropTypes.func.isRequired,
  resetEditStates: PropTypes.func.isRequired,
  resetDeleteStates: PropTypes.func.isRequired,
};

const data = (state) => ({
  couponList: state.coupon.couponList,
  listIsLoaded: state.coupon.listIsLoaded,
  isEdited: state.coupon.isEdited,
  isDeleted: state.coupon.isDeleted
});

const action = dispatch => ({
  getCouponList: (params) => dispatch({ type: GET_COUPON_LIST, payload: { ...params, resource: RESOURCE.GET_COUPON_LIST } }),
  activeCoupon: (params) => dispatch({ type: EDIT_COUPON, payload: { ...params } }),
  inactiveCoupon: (params) => dispatch({ type: EDIT_COUPON, payload: { ...params } }),
  removeCoupon: (params) => dispatch({ type: REMOVE_COUPON, payload: params }),
  resetEditStates: () => dispatch({ type: COUPON_IS_EDITED, payload: STATUS.PENDING }),
  resetDeleteStates: () => dispatch({ type: COUPON_IS_DELETED, payload: STATUS.PENDING })
});

export default connect(data, action)(CouponDetailTable);